import { Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import State from "./State/State";
import LoginTab from "./LoginTab/LoginTab";
const StateChange = () => {
	const { getSelectedTabstate, const_var, selectedTabstate } = useSelector((state) => state.reducer);
	const dispatch = useDispatch();
	const tabSelect = (key) => {
		dispatch(getSelectedTabstate(key));
		let checktab = getSelectedTabstate;
		switch (checktab) {
			case "statechange":
				alert("state");
				break;
			default:
				break;
		}
	};

	return (
		<div className="state-container">
			<Tab.Container activeKey={const_var.showLoginScreen ? "loginstyletab" : selectedTabstate} onSelect={tabSelect}>
				<Tab.Content>
					<Tab.Pane transition={false} eventKey="statechange">
						<State />
					</Tab.Pane>
					{const_var.crmSetting.is_Edit != true ? (
						<Tab.Pane transition={false} eventKey="buildingtypetab">
							<div className={const_var.defaultBuildingArr.length != 0 ? " fullpage-loader spinner-loader " : "fullpage-loader spinner-loader spinner-active "}>
								<div className="spinner-loader">
									<div className="spinner"></div>
								</div>
								<div className="spinner-content">
									<h6>Loading...</h6>
								</div>
							</div>
						</Tab.Pane>
					) : (
						<Tab.Pane>
							<></>
						</Tab.Pane>
					)}
					<Tab.Pane transition={false} eventKey="loginstyletab">
						<LoginTab />
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</div>
	);
};

export default StateChange;
